(function () {
    'use strict';

    a3_cabin_reports.directive('gdCrewInfo', gdCrewInfo);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name crewInfo
    * @restrict E
    * @description
    *   Crew Table with a double row per crew member
    * @example
    *   Usage:
    *   <gd-crew-info crew="crewMembers" grounddutyid="id"></gd-crew-info>
    * @ngInject
    */
    function gdCrewInfo($uibModal, UserFactory) {
        function link(scope) {
            scope.user = UserFactory.getUser();
            scope.openPhoneConfirmation = openPhoneConfirmation;
            scope.showInfoRow = showInfoRow;

            function openPhoneConfirmation(crew) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/CrewInfo/dlgConfirmCrewCall.html',
                    controller: 'CrewCallCtrl',
                    size: 'md',
                    resolve: {
                        crew: function () { return crew; },
                        groundDutyId: function () { return scope.grounddutyid; },
                        flightId: function () { return null; }
                    }
                });
                modalInstance.result.then(function (confirm) {

                });
            }

            function showInfoRow(item) {
                var differentUser = scope.user.aimsId != item.AIMS_ID;
                var phoneAvailable = item.PhoneNumber && item.PhoneNumber != '';

                return differentUser && phoneAvailable;
            }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/GroundDuty/gdCrewInfo.tpl.html',
            scope: { crew: "=", grounddutyid: "=" },
            link: link
        }
    }

})();
